import React from "react";
import Slider from "rc-slider";


interface RangeSliderProps {
    width: number | string;
    disabled?: boolean;
    min?: number;
    max?: number;
    defaultValue?: number;
    onChange: (sliderValue: number) => void;
}

const RangeSlider: React.FC<RangeSliderProps> = (props) => {
    const {
        width,
        disabled = false,
        min = 1,
        max =100,
        defaultValue = 50,
        onChange
    } = props;

    const onSlide = (sliderValue: number | number[]) => {
        if (Array.isArray(sliderValue)) {
            onChange(sliderValue[0]);
        } else {
            onChange(sliderValue);
        }
    };

    return (
        <div style={{ width }}>
            <Slider disabled={disabled}
                    step={1}
                    min={min}
                    max={max}
                    defaultValue={defaultValue}
                    onChange={onSlide}
                    styles={{
                        rail: {
                            border: "3px solid #E4E4E4"
                        },
                        track: {
                            border: disabled ? "3px solid #BDBDBD" : "3px solid #441A98"
                        },
                        handle: {
                            width: 13,
                            height: 13,
                            border: disabled ? "3px solid #BDBDBD" : "3px solid #441A98",
                            backgroundColor: "white",
                            opacity: 1,
                        }
                    }}
            />
        </div>
    );
};

export default RangeSlider;